import { useQueryClient } from "@tanstack/react-query";

import { filterConstants } from "../../../constants";
import {
  useGetPageQueryParams,
  useMerchantApiQueryWithParams,
  useQueryString,
  useReactRouterLink,
} from "../../../hooks";
import {
  IQueryStringNavLinks,
  ITableHeader,
  IPageAndSearchRequest,
  PagedMeta,
  IViewBatchTransfer,
} from "../../../interfaces-and-types";
import { View } from "./View";

interface ITransferBatchQueryMeta {
  status: string | null;
}

export interface ITransferViewProps {
  data: IViewBatchTransfer[];
  headers: ITableHeader[];
  query: URLSearchParams;
  isLoading: boolean;
  isError: boolean;
  totalCount: number;
  queryStringTabs: IQueryStringNavLinks;

  // modals
  openCreateNewModal: () => void;
  // openCreateNewBatchUploadExcel: () => void;
  openDetailsModal: (data: any) => void;
  refreshTable: () => void;

  // extra buttons
  onExport: () => void;
}

export const BATCH_TRANSFERS_LIST_TABLE_NAME = "trsfBatch";

export const Transfers = () => {
  const query = useQueryString();
  const status = query.get(
    `${BATCH_TRANSFERS_LIST_TABLE_NAME}.${filterConstants.statusKey}`
  );
  const { page, page_size, search } = useGetPageQueryParams({
    queryStringPrefix: BATCH_TRANSFERS_LIST_TABLE_NAME,
  });

  const { navigate, navigateToRoutePreserveParams } = useReactRouterLink();

  const {
    isLoading: isLoadingTransferBatches,
    isError: isErrorTransferBatches,
    data: transferBatches,
    meta: transferBatchesMeta,
    refetch: refetchTransferBatches,
  } = useMerchantApiQueryWithParams<
    IPageAndSearchRequest & ITransferBatchQueryMeta,
    IViewBatchTransfer[],
    PagedMeta
  >([
    "getBatchList",
    {
      page: (page && Number(page)) || 1,
      page_size: (page_size && Number(page_size)) || 10,
      search,
      status,
    },
  ]);

  const headers: ITableHeader[] = [
    {
      key: "title",
      header: "Title",
    },
    {
      key: "batch_reference_display",
      header: "Batch Reference",
    },
    {
      key: "source_currency",
      header: "Source Currency",
    },
    {
      key: "total_count",
      header: "Total Count",
    },
    {
      key: "failed_count",
      header: "Failed Count",
    },
    {
      key: "total_amount",
      header: "Total Amount",
    },
    {
      key: "total_fee",
      header: "Fees",
    },
    {
      key: "statusBadge",
      header: "Status",
    },
    {
      key: "created_at",
      header: "Created On",
    },
    // {
    //   key: "more",
    //   header: "",
    // },
  ];

  const queryStringTabs: IQueryStringNavLinks = {
    query: filterConstants.statusKey,
    options: [
      {
        key: "All",
        value: null,
      },
      {
        key: "Successful",
        value: "allSuccessful",
      },
      {
        key: "Processing",
        value: "processing",
      },
      {
        key: "Queued",
        value: "queued",
      },
      {
        key: "Partial",
        value: "partialSuccessful",
      },
      // {
      //   key: "OTP",
      //   value: "otp",
      // },
      // {
      //   key: "OTP Failure",
      //   value: "otpDispatchFailed",
      // },
      {
        key: "Failed",
        value: "allFailed",
      },
    ],
  };

  const onExport = () => {
    alert("exporting data...");
  };

  const refreshTable = () => refetchTransferBatches();

  const openDetailsModal = (batch_ref: any) =>
    navigate(`batch/${batch_ref}/transfers?${query}`);

  const openCreateNewModal = () => {
    navigate(`create?${query}`);
  };

  return (
    <>
      <View
        data={transferBatches || []}
        headers={headers}
        query={query}
        isLoading={isLoadingTransferBatches}
        isError={isErrorTransferBatches}
        totalCount={transferBatchesMeta?.page_meta.item_count || 0}
        queryStringTabs={queryStringTabs}
        onExport={onExport}
        openCreateNewModal={openCreateNewModal}
        openDetailsModal={openDetailsModal}
        refreshTable={refreshTable}
      />
    </>
  );
};
